import PropTypes from 'prop-types';
import './ErrorMessage.scss';

const ErrorMessage = ({ message }) => <span className="error-message">{message}</span>;

ErrorMessage.propTypes = {
  message: PropTypes.string
};

ErrorMessage.defaultProps = {
  message: ''
};

export default ErrorMessage;
